<template>
  <section v-if="galleryWithUrls.length" class="py-16 bg-gray-50">
    <div class="container mx-auto px-4">
      <h2 class="text-4xl font-bold mb-8 text-center text-gray-800">{{ $t('property.gallery') }}</h2>
      <div class="swiper-container">
        <swiper
          :modules="modules"
          :slides-per-view="1"
          :space-between="30"
          :pagination="{ clickable: true }"
          :navigation="true"
          :rewind="true"
          class="max-w-5xl mx-auto"
        >
          <swiper-slide v-for="(image, index) in galleryWithUrls" :key="index">
            <div class="relative h-[500px] rounded-lg overflow-hidden shadow-lg">
              <img
                :src="image.src"
                :alt="image.alt"
                class="w-full h-full object-cover"
              />
              <div class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <p class="text-white text-lg font-medium">{{ image.caption }}</p>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { resolvePropertyImageUrl } from '../../utils/propertyImageUrl.js';

const modules = [Navigation, Pagination];

const props = defineProps({
  gallery: {
    type: Array,
    required: true
  }
});

const galleryWithUrls = computed(() =>
  (Array.isArray(props.gallery) ? props.gallery : [])
    .map((img) => ({
      ...img,
      src: resolvePropertyImageUrl(img?.src)
    }))
    .filter((img) => img.src)
);
</script>

<style>
.swiper-button-next,
.swiper-button-prev {
  color: white;
  background: rgba(0, 0, 0, 0.5);
  width: 44px;
  height: 44px;
  border-radius: 50%;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 20px;
}

.swiper-pagination-bullet-active {
  background: white;
}
</style>

